import { COMPANY } from '../constants';
import { instance } from '../../axios';

const updateCompanyAction = (formData, id) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CREATE_COMPANY,
    });
    instance
      .post('/company/' + id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((results) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(reloadCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

const createCompanyAction = (formData) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CREATE_COMPANY,
    });
    instance
      .post('/company', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((results) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(reloadCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.CREATE_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

const getCompaniesAction = (limit, offset) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANIES,
      payload: { limit, offset },
    });
    instance
      .get('/company?limit=' + limit + '&offset=' + offset)
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANIES_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANIES_FAILURE,
          payload: error,
        });
      });
  };
};

// After a create, a save or a delete, reload the list page on screen: without
// limit and offset the API answers in its old format (a bare array)
const reloadCompaniesAction = () => (dispatch, getState) => {
  const { limit, offset } = getState().company.listQuery;
  dispatch(getCompaniesAction(limit, offset));
};

const getCompanyAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANY,
    });
    instance
      .get('/company/' + id)
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANY_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteCompanyAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.GET_COMPANY,
    });
    instance
      .delete('/company/' + id)
      .then((results) => {
        dispatch({
          type: COMPANY.GET_COMPANY_SUCCESS,
          payload: results.data,
        });
        dispatch(reloadCompaniesAction());
      })
      .catch((error) => {
        dispatch({
          type: COMPANY.GET_COMPANY_FAILURE,
          payload: error,
        });
      });
  };
};

const cleanCompanyAction = () => {
  return (dispatch) => {
    dispatch({
      type: COMPANY.CLEAN_COMPANY,
    });
  };
};

export {
  getCompanyAction,
  getCompaniesAction,
  cleanCompanyAction,
  createCompanyAction,
  updateCompanyAction,
  deleteCompanyAction,
};
